/**
 * Just a simple "fake" caching class
 *
 * Only caches internally in the class
 * cache is deleted when you leave page that uses this
 */
export default class DummyCache {
  constructor () {
    this.cache = {}
  }

  get (key) {
    if (this.cache.hasOwnProperty(key)) {
      return this.cache[key]
    }

    return null
  }

  set (key, value) {
    this.cache[key] = value
  }

  del (key) {
    if (this.cache.hasOwnProperty(key)) {
      delete this.cache[key]
    }
  }

  clear () {
    this.cache = {}
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dummy-cache.js